module.exports = __webpack_public_path__ + "img/gw_gxh.b80dcdc0.png";